// @generated by protoc-gen-connect-es v0.8.6 with parameter "target=ts,import_extension="
// @generated from file asset/v1/asset.proto (package asset.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import {
  ArchiveAssetRequest,
  ArchiveAssetResponse,
  ArchiveAssetsRequest,
  ArchiveAssetsResponse,
  CountAssetsRequest,
  CountAssetsResponse,
  CreateVersionRequest,
  CreateVersionResponse,
  DeleteAssetRequest,
  DeleteAssetResponse,
  DeleteAssetsRequest,
  DeleteAssetsResponse,
  EmptyArchiveRequest,
  EmptyArchiveResponse,
  GetAssetCategoriesRequest,
  GetAssetCategoriesResponse,
  GetAssetRequest,
  GetAssetResponse,
  GetAssetsRequest,
  GetAssetsResponse,
  GetDefaultAssetRequest,
  GetDefaultAssetResponse,
  ListAssetsRequest,
  ListAssetsResponse,
  ListVersionsRequest,
  ListVersionsResponse,
  MoveAssetsRequest,
  MoveAssetsResponse,
  PublishVersionRequest,
  PublishVersionResponse,
  RestoreAssetRequest,
  RestoreAssetResponse,
  RestoreAssetsRequest,
  RestoreAssetsResponse,
  SetDefaultAssetRequest,
  SetDefaultAssetResponse,
  UpdateAssetRequest,
  UpdateAssetResponse,
  UpdateAssetsRequest,
  UpdateAssetsResponse
} from './asset_pb'
import { MethodKind } from '@bufbuild/protobuf'

/**
 * @generated from service asset.v1.AssetService
 */
export const AssetService = {
  typeName: 'asset.v1.AssetService',
  methods: {
    /**
     * Defaults
     *
     * @generated from rpc asset.v1.AssetService.GetDefaultAsset
     */
    getDefaultAsset: {
      name: 'GetDefaultAsset',
      I: GetDefaultAssetRequest,
      O: GetDefaultAssetResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.SetDefaultAsset
     */
    setDefaultAsset: {
      name: 'SetDefaultAsset',
      I: SetDefaultAssetRequest,
      O: SetDefaultAssetResponse,
      kind: MethodKind.Unary
    },
    /**
     * Mutations
     *
     * @generated from rpc asset.v1.AssetService.UpdateAsset
     */
    updateAsset: {
      name: 'UpdateAsset',
      I: UpdateAssetRequest,
      O: UpdateAssetResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.UpdateAssets
     */
    updateAssets: {
      name: 'UpdateAssets',
      I: UpdateAssetsRequest,
      O: UpdateAssetsResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.ArchiveAsset
     */
    archiveAsset: {
      name: 'ArchiveAsset',
      I: ArchiveAssetRequest,
      O: ArchiveAssetResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.ArchiveAssets
     */
    archiveAssets: {
      name: 'ArchiveAssets',
      I: ArchiveAssetsRequest,
      O: ArchiveAssetsResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.RestoreAsset
     */
    restoreAsset: {
      name: 'RestoreAsset',
      I: RestoreAssetRequest,
      O: RestoreAssetResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.RestoreAssets
     */
    restoreAssets: {
      name: 'RestoreAssets',
      I: RestoreAssetsRequest,
      O: RestoreAssetsResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.DeleteAsset
     */
    deleteAsset: {
      name: 'DeleteAsset',
      I: DeleteAssetRequest,
      O: DeleteAssetResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.DeleteAssets
     */
    deleteAssets: {
      name: 'DeleteAssets',
      I: DeleteAssetsRequest,
      O: DeleteAssetsResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.MoveAssets
     */
    moveAssets: {
      name: 'MoveAssets',
      I: MoveAssetsRequest,
      O: MoveAssetsResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.EmptyArchive
     */
    emptyArchive: {
      name: 'EmptyArchive',
      I: EmptyArchiveRequest,
      O: EmptyArchiveResponse,
      kind: MethodKind.Unary
    },
    /**
     * Queries
     *
     * @generated from rpc asset.v1.AssetService.GetAsset
     */
    getAsset: {
      name: 'GetAsset',
      I: GetAssetRequest,
      O: GetAssetResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.GetAssets
     */
    getAssets: {
      name: 'GetAssets',
      I: GetAssetsRequest,
      O: GetAssetsResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.GetAssetCategories
     */
    getAssetCategories: {
      name: 'GetAssetCategories',
      I: GetAssetCategoriesRequest,
      O: GetAssetCategoriesResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.ListAssets
     */
    listAssets: {
      name: 'ListAssets',
      I: ListAssetsRequest,
      O: ListAssetsResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.CountAssets
     */
    countAssets: {
      name: 'CountAssets',
      I: CountAssetsRequest,
      O: CountAssetsResponse,
      kind: MethodKind.Unary
    },
    /**
     * Versions
     *
     * @generated from rpc asset.v1.AssetService.CreateVersion
     */
    createVersion: {
      name: 'CreateVersion',
      I: CreateVersionRequest,
      O: CreateVersionResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.PublishVersion
     */
    publishVersion: {
      name: 'PublishVersion',
      I: PublishVersionRequest,
      O: PublishVersionResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc asset.v1.AssetService.ListVersions
     */
    listVersions: {
      name: 'ListVersions',
      I: ListVersionsRequest,
      O: ListVersionsResponse,
      kind: MethodKind.Unary
    }
  }
} as const
